<svg
  width="20"
  height="20"
  viewBox="0 0 20 20"
  fill="none"
  xmlns="http://www.w3.org/2000/svg"
>
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M16.2897 10.1487C16.2897 9.68414 16.248 9.23743 16.1705 8.80859H10V11.3429H13.526C13.3741 12.1619 12.9125 12.8558 12.2187 13.3203V14.9642H14.3361C15.5749 13.8236 16.2897 12.144 16.2897 10.1487Z"
    fill="#4285F4"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.0013 16.5515C11.7703 16.5515 13.2534 15.9648 14.3374 14.9642L12.22 13.3203C11.6333 13.7134 10.8828 13.9457 10.0013 13.9457C8.29492 13.9457 6.85056 12.7932 6.33536 11.2446H4.14648V12.9421C5.22454 15.0833 7.44021 16.5515 10.0013 16.5515Z"
    fill="#34A853"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M6.33496 11.2448C6.20392 10.8517 6.12947 10.4318 6.12947 9.99994C6.12947 9.56812 6.20392 9.14821 6.33496 8.75511V7.05762H4.14608C3.70235 7.9421 3.44922 8.94273 3.44922 9.99994C3.44922 11.0571 3.70235 12.0578 4.14608 12.9423L6.33496 11.2448Z"
    fill="#FBBC05"
  />
  <path
    fill-rule="evenodd"
    clip-rule="evenodd"
    d="M10.0013 6.05404C10.9633 6.05404 11.8269 6.38461 12.5059 7.03382L14.385 5.15467C13.2504 4.09746 11.7673 3.44824 10.0013 3.44824C7.44022 3.44824 5.22454 4.91642 4.14648 7.05765L6.33536 8.75514C6.85056 7.20655 8.29492 6.05404 10.0013 6.05404Z"
    fill="#EA4335"
  />
</svg>
